import {abbreviations} from "@/entities/User/config";

import {ContextCompany} from "./types";

/**
 * Подставляет короткое название по аббревиатурам там, где бэк его не прислал.
 * Возвращает новый массив: данные лежат в кэше query, мутировать их нельзя.
 */
export const formatCompanies = (companies: ContextCompany[]): ContextCompany[] =>
    companies.map(company => {
        if (company.shortNameRu) return company;

        const shortNameRu = abbreviations.reduce(
            (name, {pattern, substring}) => name.replace(pattern, substring),
            company.nameRu,
        );

        return shortNameRu === company.nameRu ? company : {...company, shortNameRu};
    });
